import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { TransformationExecution } from '../../../../../../../typings/TransformationExecution.interface';
import TransformationExecutionsList from './TransformationExecutionsList';
import Filters from '../../../common/Filters/Filters';
import { transformation_execution_list_filters } from '../../../common/Filters/FilterComponents';
import { TransformationExecutionsQueryProps } from '../../../../typings/TransformationExecution.interface';
import useSearchQuery from '../../../hooks/useSearchQuery';
import { extractFiltersFromQuery } from './TransformationExecutionsView';
import { Div } from '../../../common/helpers/StyledUtils';
import Divider from '../../../common/base/Divider';
interface TransformationExecutionsProps {
  transformation_id: string;
  selected_execution_id?: string;
  onExecutionSelected: (selected_execution_id: string) => void;
  onPaginationChanged: (pagination: {
    page?: number;
    limit?: number;
  }) => void;
}
export const TransformationExecutions = t0 => {
  const $ = _c(23);
  const {
    transformation_id,
    selected_execution_id,
    onExecutionSelected,
    onPaginationChanged
  } = t0;
  const history = useHistory();
  const location = useLocation();
  const {
    query,
    updateSearchQuery
  } = useSearchQuery();
  let t1;
  if ($[0] !== query) {
    t1 = extractFiltersFromQuery(query);
    $[0] = query;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const filters = t1;
  let t2;
  if ($[2] !== updateSearchQuery) {
    t2 = new_filters => {
      updateSearchQuery(new_filters, {
        remove_keys: ["selected_execution_id", "next", "prev"],
        replace: true
      });
    };
    $[2] = updateSearchQuery;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onFilterChanged = t2;
  let t3;
  if ($[4] !== history || $[5] !== location) {
    t3 = execution => {
      history.push({
        ...location,
        search: execution ? `?input_execution_id=${execution.id}` : "",
        pathname: location.pathname.replace("/executions", "/edit"),
        state: {
          from: location.state?.from
        }
      });
    };
    $[4] = history;
    $[5] = location;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const onEdit = t3;
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      align: "flex-start",
      gap: 3
    };
    t5 = {
      x: 6,
      y: 3
    };
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  if ($[9] !== filters || $[10] !== onFilterChanged) {
    t6 = <Div flex={t4} p={t5}><Filters route="transformation-executions" filters={filters} components={transformation_execution_list_filters} onFilterChanged={onFilterChanged} /></Div>;
    $[9] = filters;
    $[10] = onFilterChanged;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Divider />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== filters || $[14] !== onEdit || $[15] !== onExecutionSelected || $[16] !== onPaginationChanged || $[17] !== selected_execution_id || $[18] !== transformation_id) {
    t8 = <TransformationExecutionsList transformation_id={transformation_id} selected_execution_id={selected_execution_id} filters={filters} onExecutionSelected={onExecutionSelected} onPaginationChanged={onPaginationChanged} onEdit={onEdit} />;
    $[13] = filters;
    $[14] = onEdit;
    $[15] = onExecutionSelected;
    $[16] = onPaginationChanged;
    $[17] = selected_execution_id;
    $[18] = transformation_id;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t6 || $[21] !== t8) {
    t9 = <>{t6}{t7}{t8}</>;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};